<dx-popup title="Dumpster" [width]="400" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="dumpster" class="mb-4" validationGroup="mainValidationGroup">
        <dxi-form-item dataField="size"> </dxi-form-item>
        <dxi-form-item dataField="basePrice" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="extendedPrice" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="outerPrice" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="kalamazooPrice" [editorOptions]="{ format: { type: 'currency', precision: 2 } }">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item dataField="weightLimit" [editorOptions]="{ format: { type: 'fixedPoint', precision: 2 } }">
            <dxi-form-validation-rule type="required" message="Required"> </dxi-form-validation-rule>
        </dxi-form-item>
        <dxi-form-item
            dataField="categoryId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: dumpsterCategories, valueExpr: 'id', displayExpr: 'name' }"
            [label]="{ text: 'Category' }"
        >
        </dxi-form-item>
        <dxi-form-item dataField="trackInventory" editorType="dxCheckBox"> </dxi-form-item>
        <dxi-form-item dataField="chargeKentFee" editorType="dxCheckBox"> </dxi-form-item>
        <dxi-form-item dataField="chargeMichiganFee" editorType="dxCheckBox"> </dxi-form-item>
        <dxi-form-item dataField="includeTonExpense" editorType="dxCheckBox"> </dxi-form-item>
    </dx-form>
</dx-popup>
